import { object, constants } from 'common/helpers'
import { getCookieValue } from 'helpers'

// todo @vkudla remove dublicates logic for closing banners
export const initialState = {
  locale: getCookieValue(constants.cookieNames.locale, true) || 'en',
  isSideMenuVisible: false,
  isProfileMenuVisible: false,
  isRequestLoaderVisible: false,
  headerActiveDropMenuName: null,
  headerSubNavDropMenuActiveIndex: null,
  isProfileInviteBlockVisible: (() => {
    const cookieValue = getCookieValue(constants.cookieNames.isProfileInviteBlockVisible, true)

    return typeof cookieValue !== 'undefined' ? cookieValue : true
  })(),
  isPayPalBannerVisible: (() => {
    const cookieValue = getCookieValue(constants.cookieNames.isPayPalBannerVisible, true)

    return typeof cookieValue !== 'undefined' ? cookieValue : true
  })(),
  isImproveSurveyBannerHidden: Boolean(getCookieValue(constants.cookieNames.isImproveSurveyBannerHidden, true)),
  isFragranceConceptsBannerHidden: Boolean(getCookieValue(constants.cookieNames.isFragranceConceptsBannerHidden, true)),
  banners: {
    RecommendationsImproveBanner: Boolean(getCookieValue(constants.cookieNames.banners.recommendationsImprove, true)),
  },
  closedPopups: {}, // already closed popups
}

export const setRequestLoaderVisibility = (state, payload) => (
  { ...state, isRequestLoaderVisible: payload }
)

export const setLocale = (state, payload) => (
  { ...state, locale: payload }
)

export const setSideMenuVisibility = (state, payload) => (
  { ...state, isSideMenuVisible: payload }
)

export const setProfileMenuVisibility = (state, payload) => (
  { ...state, isProfileMenuVisible: payload }
)

export const setHeaderActiveDropMenuName = (state, payload /* name */) => (
  { ...state, headerActiveDropMenuName: payload }
)

export const setHeaderSubNavDropMenuActiveIndex = (state, payload /* index */) => (
  { ...state, headerSubNavDropMenuActiveIndex: payload }
)

export const setProfileInviteBlockVisibility = (state, payload) => (
  { ...state, isProfileInviteBlockVisible: payload }
)

export const setPayPalBannerVisibility = (state, payload) => (
  { ...state, isPayPalBannerVisible: payload }
)

export const setImproveSurveyBannerHiddenStatus = (state, payload) => (
  { ...state, isImproveSurveyBannerHidden: payload }
)

export const setFragranceConceptsBannerHiddenStatus = (state, payload) => (
  { ...state, isFragranceConceptsBannerHidden: payload }
)

export const setClosedPopup = (state, { name, value }) => (
  object.setIn(state, [ 'closedPopups', name ], value)
)

export const setClosedPopups = (state, payload) => (
  { ...state, closedPopups: payload || {} }
)

export const setBannerHiddenStatus = (state, payload) => (
  object.setIn(state, [ 'banners', payload ], true)
)
